import { render, staticRenderFns } from "./pageElementFilesDialog.vue?vue&type=template&id=beee9424&"
import script from "./pageElementFilesDialog.vue?vue&type=script&lang=js&"
export * from "./pageElementFilesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports